<template>
  <div class="login">
    <div class="top container">
      <router-link to="/">
        <img src="@/assets/images/logo.png" class="logo" alt />
      </router-link>
      <div class="split-line mx-3"></div>
      <span class="title">欢迎登陆</span>
    </div>
    <div class="content">
      <div class="box">
        <h3 class="title">登陆</h3>
        <form>
          <input
            type="text"
            name="accountName"
            placeholder="请输入姓名"
            v-model="accountName"
          />
          <input
            type="password"
            name="password"
            placeholder="请输入密码"
            v-model="password"
          />
          <div class="verify-block">
            <input
              type="text"
              class="verify-code-input"
              placeholder="请输入验证码"
              v-model="code"
            />
            <verify-code
              class="verify-code-img"
              ref="verifyCodeImg"
              @input="getCode"
            ></verify-code>
            <span class="verify-code-refresh" @click="refreshCode">换一个</span>
          </div>
          <div class="hint">
            <span>还没有账号？</span
            ><router-link class="registe" to="/registe">免费注册</router-link>
          </div>
          <button class="submit-button" @click.stop.prevent="submit">
            登陆
          </button>
        </form>
      </div>
    </div>
    <footer class="auth-footer px-2 px-md-0">
      <p class="copyright">
        COPYRIGHT © 2002-2019 333F.COM.INC.ALL RIGHTS RESERVED.粤ICP备10217460号
      </p>
      <div class="share-link-block">
        <a class="link mr-3" href="http://www.333f.com/" target="_blank"
          >广州市三川田文化科技股份有限公司</a
        >
        <a class="link" href="#" target="_blank">广州小包子数据科技有限公司</a>
      </div>
    </footer>
  </div>
</template>
<style lang="scss" scoped>
.login {
  .top {
    height: 10rem;
    display: flex;
    align-items: center;
    .split-line {
      background-color: #ccc;
      width: 0.13rem;
      height: 3rem;
    }
    .title {
      font-size: 1.63rem;
      color: #666666;
    }
  }
  .content {
    height: 48rem;
    width: 100%;
    background-image: url(../assets/images/auth_bg.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
    position: relative;
    .box {
      background-color: #e6eaf3;
      padding: 2rem 2.5rem;
      max-width: 28.44rem;
      width: 90%;
      position: absolute;
      top: 15%;
      right: 5%;
      input[type='text'],
      input[type='password'] {
        display: block;
        margin-bottom: 1.25rem;
        width: 100%;
        height: 2.88rem;
        background-color: #ffffff;
        border-radius: 0.25rem;
        border: solid 0.06rem #cccccc;
        outline: none;
        font-size: 0.88rem;
        padding-left: 0.63rem;
        &::placeholder {
          color: #999999;
        }
      }
      .verify-block {
        margin-bottom: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .verify-code-input {
          width: 40%;
          margin-bottom: 0;
        }
        .verify-code-refresh {
          white-space: nowrap;
          cursor: pointer;
          font-size: 1.13rem;
          color: #333333;
        }
      }
      .hint {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1.88rem;
        span {
          font-size: 1rem;
          color: #999999;
        }
        .registe {
          color: $acentColor;
          text-decoration: none;
        }
      }
      .submit-button {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2.88rem;
        color: white;
        background-color: $acentColor;
        outline: none;
        border: none;
      }
    }
  }
  .auth-footer {
    height: 9.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .copyright {
      color: #333;
      font-size: 0.75rem;
    }
    .share-link-block {
      text-align: center;
      .link {
        font-size: 0.88rem;
        color: #333;
        text-decoration: underline;
        white-space: nowrap;
      }
    }
  }
}
</style>

<script>
import VerifyCode from '@/components/VerifyCode';
import ApiService from '@/common/api.service';
import { mapMutations } from 'vuex';
import qs from 'qs';
export default {
  created() {
    this.setAuth(true);
  },
  data() {
    return {
      // 输入的验证码
      code: '',
      // 正确的验证码
      currentCode: '',
      accountName: '',
      password: ''
    };
  },
  components: {
    VerifyCode
  },
  methods: {
    getCode(code) {
      this.currentCode = code;
    },
    refreshCode() {
      this.$refs.verifyCodeImg.refreshCode();
    },
    isCodeCorrect() {
      return this.currentCode.toLowerCase() === this.code.toLowerCase();
    },
    submit() {
      let isProd = process.env.NODE_ENV === 'production';
      if (isProd && !this.isCodeCorrect()) {
        window.alert('验证码错误');
        this.refreshCode();
        return;
      }
      let data = {
        accountName: this.accountName,
        password: this.password
      };
      ApiService.post('/login/login.htm', qs.stringify(data))
        .then(data => {
          this.login({ token: data.token, accountName: this.accountName });
          this.$router.push('/');
        })
        .catch(error => {
          if (error.errorno == 10) {
            window.alert(error.errormsg);
          } else {
            window.alert(error.errormsg);
          }
        });
    },
    ...mapMutations(['login', 'setAuth'])
  }
};
</script>
